import { ApolloClient, gql, NormalizedCacheObject, useQuery } from "@apollo/client";
import { Query, QueryGetAuthorsArgs } from "../types/generated/graphql";

export const useGetAuthors = (client: ApolloClient<NormalizedCacheObject>, uid: string) => {
  type T = Pick<Query, 'getAuthors'>;
  type I = QueryGetAuthorsArgs;
  const ret = useQuery<T, I>(QUERY_GET_AUTHORS, {
    client, variables: { uid },
    fetchPolicy: "network-only", // Always fetch from the server
  });

  return ret;
}

const QUERY_GET_AUTHORS = gql`
  query getAuthors($uid: ID!) {
    getAuthors(uid: $uid) {
      id
      name
      url
      thumbnails {
        url
        width
        height
      }
      is_moderator
      is_verified
      is_verified_artist
    }
  }
`;
